import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  style: {"padding":"0px 12px 0px 16px"},
  src: "/assets/icon/btn_back.png",
  srcset: "/assets/icon/btn_back@2x.png 2x,/assets/icon/btn_back@3x.png 3x"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_ag_box = _resolveComponent("ag-box")!
  const _component_ag_text = _resolveComponent("ag-text")!
  const _component_ion_progress_bar = _resolveComponent("ion-progress-bar")!
  const _component_ag_header = _resolveComponent("ag-header")!
  const _component_ag_content = _resolveComponent("ag-content")!
  const _component_ag_button = _resolveComponent("ag-button")!
  const _component_ag_footer = _resolveComponent("ag-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ag_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ag_box, {
          dp: "flex",
          "align-items": "center",
          p: "3px 0px 20px 0px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ag_box, {
              class: "ion-activatable ripple-parent",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
            }, {
              default: _withCtx(() => [
                _hoisted_1,
                _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
              ]),
              _: 1
            }),
            _createVNode(_component_ag_text, {
              color: "black",
              typography: "tit18b"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.modalPage.title), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_ion_progress_bar, {
          value: _ctx.modalPage.progress
        }, null, 8, ["value"])
      ]),
      _: 1
    }),
    _createVNode(_component_ag_content, { id: "pt__ionContent" }, {
      default: _withCtx(() => [
        _createVNode(_component_ag_box, { height: "100%" }, {
          default: _withCtx(() => [
            _createVNode(_component_ag_box, { "margin-top": "30px" }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.modalPage.component), {
                  parent: _ctx.clickScreen,
                  "stake-name": _ctx.dealInfo.partnershipName,
                  onNotYet: _cache[1] || (_cache[1] = () => _ctx.buttonDisabled = true),
                  onAllCheck: _cache[2] || (_cache[2] = ($event: any) => (_ctx.readyToGo($event))),
                  onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:modelValue', false)))
                }, null, 8, ["parent", "stake-name"]))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ag_footer, null, {
      default: _withCtx(() => [
        _createVNode(_component_ag_box, { dp: "flex" }, {
          default: _withCtx(() => [
            _createVNode(_component_ag_button, {
              block: "lg",
              grow: "1",
              corner: "0px",
              fill: "bg2",
              onClickCapture: _cache[4] || (_cache[4] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'조합참여 위험안내 하단버튼', 'clickContent':`${_ctx.modalPage.leftButton}`});_ctx.goToPrevious()})
            }, {
              bottom: _withCtx(() => [
                _createVNode(_component_ag_box, { pb: "safeAreaBottom" })
              ]),
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.modalPage.leftButton) + " ", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_ag_button, {
              block: "lg",
              grow: "1",
              corner: "0px",
              disabled: _ctx.buttonDisabled,
              onClickCapture: _cache[5] || (_cache[5] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'조합참여 위험안내 하단버튼', 'clickContent':`${_ctx.modalPage.rightButton}`});_ctx.goToNext()})
            }, {
              bottom: _withCtx(() => [
                _createVNode(_component_ag_box, { pb: "safeAreaBottom" })
              ]),
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.modalPage.rightButton) + " ", 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}